function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.334h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M427.757 295.819c4.907-6.752 8.185-14.997 8.185-24.982v-74.203a36.93 36.93 0 01-22.261 7.421c-12.138 0-22.912-5.829-29.682-14.839-6.77 9.01-17.544 14.839-29.682 14.839a36.943 36.943 0 01-22.261-7.418v74.201c0 9.985 3.278 18.232 8.185 24.982h87.516z",
  fill: "#f3f3f3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M412.32 257.071c2.362-5.763 4.2-14.188 4.2-18.382 0-6.737-8.783-12.198-8.783-12.198s-8.783 5.461-8.783 12.198c0 4.194 1.838 12.619 4.2 18.382l-5.07 11.448a25.56 25.56 0 009.653 1.885 25.56 25.56 0 009.653-1.885l-5.07-11.448zm-34.326-37.067c-6.171.836-14.385 3.459-18.017 5.556-5.835 3.369-6.173 13.704-6.173 13.704s9.121 4.875 14.955 1.507c3.632-2.097 10.008-7.9 13.816-12.828l12.451-1.333a25.618 25.618 0 00-3.194-9.302 25.583 25.583 0 00-6.459-7.418l-7.379 10.114zm-14.935 48.263c3.809 4.925 10.187 10.728 13.818 12.824 5.835 3.368 14.955-1.507 14.955-1.507s-.339-10.336-6.173-13.705c-3.633-2.097-11.846-4.717-18.019-5.552l-7.378-10.115a25.627 25.627 0 00-6.459 7.416 25.602 25.602 0 00-3.194 9.304l12.45 1.335z",
  fill: "#ff9811"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M338.408 293.099C352.267 315.335 384 322.778 384 322.778s31.733-7.443 45.592-29.679h-91.184z",
  fill: "#338af3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M256 186.665H144.006v69.331H160v-48.918l73.372 48.918H256l-80.006-53.337h22.628L256 240.915v-7.535l-46.069-30.72H256v-15.995zm-80.006-48.005L256 85.334h-22.628L160 134.241V85.334h-15.994v69.331H256V138.66h-46.069L256 107.951v-7.535l-57.377 38.244h-22.629zM96 85.334v48.907L22.628 85.334H0l80.006 53.326H57.377L0 100.415v7.536l46.069 30.709H0v16.006h111.994V85.334H96zM0 186.665v15.994h46.069L0 233.38v7.535l57.377-38.255h22.628L0 255.997h22.628L96 207.078v48.918h15.994v-69.331H0z",
  fill: "#f0f0f0"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.329h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 138.663L0 85.329v15.083l57.377 38.251zm96 0h22.623L256 100.412V85.329zm-118.623 64L0 240.915v15.082l80-53.334zm118.623 0l80 53.334v-15.082l-57.377-38.252z"
}));

const SvgAnguilla = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnguilla, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/anguilla.040c7f09.svg";
export { ForwardRef as ReactComponent };